import {
  ExploreAggColumnType,
  ExploreColumnType,
  ExploreGroupByColumnType,
} from "@/v2/entities/explore/columns/ExploreColum.model";
import {
  AllowedAggOrderBy,
  AllowedInteractionOrderBy,
} from "./ExploreDisplayOptions.model";

export const conversationsNotAllowedGroupBy: ExploreGroupByColumnType[] = [
  "agentAssigned",
  "day",
  "week",
  "month",
  "team",
  "status",
  "channel",
  "avgQaScore",
  "avgSentiment",
  "subTopic",
  "tenantId",
  "escalationReason",
  "skipReason",
  "resolvedReason",
  "scoreTitle",
  "scoreContent",
];

export const ticketsNotAllowedGroupBy: ExploreGroupByColumnType[] = [
  "day",
  "week",
  "month",
  "status",
  "channel",
  "avgQaScore",
  "avgQuackMessageScoreRoundRange",
  "avgSentiment",
  "tenantId",
  "escalationReason",
  "skipReason",
  "resolvedReason",
  "originUrl",
  "scoreTitle",
  "scoreContent",
  "simulator",
];

export const orderableColumns: AllowedInteractionOrderBy[] = [
  "subject",
  "description",
  "createdAt",
  "updatedAt",
  "topic",
  "status",
  "csat",
  "avgQaScore",
  "avgAutoQaScore",
  "avgQaScoreRoundRange",
  "avgSentiment",
];

export const orderableMetricAggColumns: AllowedAggOrderBy[] = [
  "volume",
  "volumeRatio",
  "avgQuackMessages",
  "avgQaScore",
  "avgAutoQaScore",
  "avgSentiment",
  "avgCsat",
  "avgTimeToResolution",
  "avgTimeToFirstResponse",
  "avgPublicMessages",
  "avgInternalMessages",
  "countAgentsAssigned",
];

export const mandatoryColumns: ExploreColumnType[] = ["subject", "displayId"];

// Add default selected columns for each source
export const defaultTicketsColumns: ExploreColumnType[] = [
  "subject",
  "displayId",
  "description",
  "createdAt",
  "status",
  "channel",
  "topic",
  "agentAssigned",
];

export const defaultConversationsColumns: ExploreColumnType[] = [
  "subject",
  "displayId",
  "description",
  "createdAt",
  "channel",
  "topic",
  "countQuackMessages",
];

// Add default agg columns
export const defaultTicketsAggColumns: ExploreAggColumnType[] = [
  "volume",
  "avgQaScore",
  "avgSentiment",
  "avgTimeToResolution",
];

export const defaultConversationsAggColumns: ExploreAggColumnType[] = [
  "volume",
  "avgQuackMessages",
  "avgSentiment",
];
